import { useEffect, useState } from "react";
import { DataTable } from "@/components/fleet/DataTable";
import { api, fmtDate } from "@/lib/api";

const EVENT = { accepted: "Driver accepted", arrived: "Driver arrived", completed: "Trip completed", expired: "No driver found" };

export const SmsPanel = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/sms").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  return (
    <div className="space-y-4">
      <p data-testid="sms-test-mode-banner" className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
        Test mode: SMS messages are recorded here but not sent to phones yet. Add an SMS provider (e.g. Twilio) to start delivering them.
      </p>
      <DataTable
        testId="sms-log-table"
        rows={rows}
        empty="No SMS alerts yet. They are created when a driver accepts, arrives and completes a ride."
        cols={[
          ["When", (r) => fmtDate(r.created_at)],
          ["To", (r) => <div><p className="font-semibold text-slate-900">{r.customer_name}</p><p className="text-xs text-slate-400">{r.to || "no phone"}</p></div>],
          ["Event", (r) => EVENT[r.event] || r.event],
          ["Message", (r) => <span className="block max-w-[420px] whitespace-normal text-xs">{r.body}</span>],
          ["Status", () => <span className="rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-semibold text-amber-800">Test mode</span>],
        ]}
      />
    </div>
  );
};
